import Morph from "../components/Morph";
import HeroSlider, { Overlay, Slide} from "hero-slider";
import Gallery from "../components/Gallery";
import Logos from "../components/Logos";
import { Link } from "react-router-dom";
import crowd from "../assets/crowd.png";
import Fade from 'react-reveal/Fade';

// const a = "https://images.unsplash.com/photo-1472173148041-00294f0814a2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=100";
const b = "https://images.unsplash.com/photo-1546778316-dfda79f1c84e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=100";
const c = "https://images.unsplash.com/photo-1597735881932-d9664c9bbcea?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=683&q=100";
const d = "https://images.unsplash.com/photo-1518593445014-07551dc02331?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1173&q=100";

const Landing = () => {

	const randomNumber = Math.floor(Math.random() * 4) + 1;

	return (
		<div className="-z-20">
			<Fade>
				<HeroSlider
					autoplay={{
						autoplayDuration: 7250
					}}
					controller={{
						initialSlide: randomNumber,
						slidingDuration: 1500,
						slidingDelay: 0
					}}
					animations={{
						slidingAnimation: 'fade',
						sliderFadeInDuration: 0
					}}
					accessability={{
					shouldDisplayButtons: false,
					shouldSlideOnArrowKeypress: false
					}}
					>
					<Overlay>
						<div className="flex flex-col justify-center h-screen">
							<div className="z-10 text-center"><Morph /></div>
							<div className="text-lg text-center -mt-36 md:text-xl lg:text-2xl"><span className="bg-slate-100 text-black py-2 px-4">May 11<sup>th</sup>, 12<sup>th</sup>, 13<sup>th</sup> | 2023</span></div>
						</div>
					</Overlay>

					{/* <Slide
						label="a"
						background={{
							backgroundImageSrc: a
						}}
					/> */}

					<Slide
						label="b"
						background={{
							backgroundImageSrc: b
						}}
					/>

					<Slide
						label="c"
						background={{
							backgroundImageSrc: c
						}}
					/>

					<Slide
						label="d"
						background={{
							backgroundImageSrc: d
						}}
					/>

				</HeroSlider>
			</Fade>

			<Fade bottom><Logos /></Fade>

			<div className="relative">
				<div className="absolute bg-gradient-to-t from-lime-600 via-amber-600 to-red-500 inset-0 animated-gradient"></div>
				<Fade bottom><p className="absolute z-10 top-8 text-3xl w-screen text-center md:top-20 md:text-5xl lg:text-7xl xl:text-8xl 2xl:text-9xl font-bold">Do you have what it takes?</p></Fade>
				<img className="relative object-cover h-80 z-50 w-full lg:h-max" alt="winning-house-silhouette" src={crowd}/>
			</div>

			<Fade bottom cascade duration={1500}>
				<div className="select-none text-center flex flex-wrap justify-center mt-5 md:justify-center gap-0 md:flex-nowrap md:gap-6 md:mt-16 md:mx-12 lg:gap-10 lg:mx-36">
					<Link className="relative group select-none flex justify-center items-end w-5/6 h-72 my-5 rounded-sm overflow-hidden md:w-1/4 lg:h-96 xl:w-1/5" to="/events" state={"individual"}>
						<div className="select-none absolute z-10 inset-0 bg-gradient-to-t from-black opacity-75" />
						<img className="select-none object-cover opacity-75 w-full h-full ease-in-out duration-500 group-hover:scale-110" alt="individual" src="https://images.unsplash.com/photo-1590225472433-e20c5d118c60?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80" />
						<p className="select-none absolute z-20 py-8 text-3xl font-semibold ease-in-out duration-500 group-hover:scale-110 md:text-xl lg:text-2xl xl:text-3xl">Individual Events</p>
					</Link>
					<Link className="relative group select-none flex justify-center items-end w-5/6 h-72 my-5 rounded-sm overflow-hidden md:w-1/4 lg:h-96 xl:w-1/5" to="/events" state={"team"}>
						<div className="select-none absolute z-10 inset-0 bg-gradient-to-t from-black opacity-75" />
						<img className="select-none object-cover opacity-75 w-full h-full ease-in-out duration-500 group-hover:scale-110" alt="team" src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" />
						<p className="select-none absolute z-20 py-8 text-3xl font-semibold ease-in-out duration-500 group-hover:scale-110 md:text-xl lg:text-2xl xl:text-3xl">Team Events</p>
					</Link>
					<Link className="relative group select-none flex justify-center items-end w-5/6 h-72 my-5 rounded-sm overflow-hidden md:w-1/4 lg:h-96 xl:w-1/5" to="/events" state={"music"}>
						<div className="select-none absolute z-10 inset-0 bg-gradient-to-t from-black opacity-75" />
						<img className="select-none object-cover opacity-75 w-full h-full ease-in-out duration-500 group-hover:scale-110" alt="musical" src="https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" />
						<p className="select-none absolute z-20 py-8 text-3xl font-semibold ease-in-out duration-500 group-hover:scale-110 md:text-xl lg:text-2xl xl:text-3xl">Music Events</p>
					</Link>
					<Link className="relative group select-none flex justify-center items-end w-5/6 h-72 my-5 rounded-sm overflow-hidden md:w-1/4 lg:h-96 xl:w-1/5" to="/scoreboard">
						<div className="select-none absolute z-10 inset-0 bg-gradient-to-t from-black opacity-75" />
						<img className="select-none object-cover opacity-75 w-full h-full ease-in-out duration-500 group-hover:scale-110" alt="scoreboard" src="https://images.unsplash.com/photo-1590764258299-0f91fa7f95e8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" />
						<p className="select-none absolute z-20 py-8 text-3xl font-semibold ease-in-out duration-500 group-hover:scale-110 md:text-xl lg:text-2xl xl:text-3xl">Scoreboard</p>
					</Link>
				</div>
			</Fade>

			<Fade delay={200}>
				<div className="flex flex-col items-center">
					<div className="my-6 p-6 text-center md:text-lg md:w-4/6 md:p-10 lg:p-16">
						<h3 className="text-3xl font-semibold py-2 lg:text-5xl lg:py-10">About Bharatham</h3>
						<p className="font-light">Bharatham is the annual cultural festival of Rajagiri School of Engineering and Technology where students compete in a variety of events as part of their respective houses: Mughals, Rajputs, Spartans, Vikings, and Aryans. The festival showcases the talents of the students in music, dance, theater, and various other cultural events.</p>
					</div>
					<div className="my-12 md:mt-20 md:mb-0 md:w-full">
						<Gallery />
					</div>
				</div>
			</Fade>

		</div>
    );
};

export default Landing;
